import {
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useResourcesContext } from "app/contexts/resources";
import { useInscripcionContext } from "../../inscripcion-context";
import { useStepperContext } from "app/contexts/stepper";

export function AfiliacionForm() {
  const { formasDePago, frecuenciasDePago } = useResourcesContext();

  const stepper = useStepperContext();
  const { empresa, setEmpresa } = useInscripcionContext();

  function handleSubmit(e) {
    e.preventDefault();

    if (!!empresa.empresa_afiliada) {
      const confirmed = window.confirm(
        "La empresa estará afiliada a la CCIA ¿Desea continuar?"
      );

      if (!confirmed) {
        return;
      }
    }

    return stepper.next();
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline">
              <strong>
                Afiliación a la Cámara de Comercio e Industrias de Atlántida
              </strong>
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={empresa.empresa_afiliada}
                    onChange={(e) =>
                      setEmpresa((empresa) => ({
                        ...empresa,
                        empresa_afiliada: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿La empresa desea afiliarse?"
              />
            </FormGroup>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl size="small" fullWidth required>
              <InputLabel id="forma-de-pago-label">Forma de pago</InputLabel>

              <Select
                label="Forma de pago"
                labelId="forma-de-pago-label"
                value={empresa.forma_de_pago_id || ""}
                onChange={(e) =>
                  setEmpresa((empresa) => ({
                    ...empresa,
                    forma_de_pago_id: e.target.value,
                  }))
                }
                disabled={!empresa.empresa_afiliada}
                required={!!empresa.empresa_afiliada}
              >
                {formasDePago.results.map((forma) => (
                  <MenuItem
                    key={forma.forma_de_pago_id}
                    value={forma.forma_de_pago_id}
                  >
                    {forma.forma_de_pago_nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl size="small" fullWidth required>
              <InputLabel id="frecuencia-de-pago-label">
                Frecuencia de pago
              </InputLabel>

              <Select
                label="Frecuencia de pago"
                labelId="frecuencia-de-pago-label"
                value={empresa.frecuencia_de_pago_id || ""}
                onChange={(e) =>
                  setEmpresa((empresa) => ({
                    ...empresa,
                    frecuencia_de_pago_id: e.target.value,
                  }))
                }
                disabled={!empresa.empresa_afiliada}
                required={!!empresa.empresa_afiliada}
              >
                {frecuenciasDePago.results.map((frecuencia) => (
                  <MenuItem
                    key={frecuencia.frecuencia_de_pago_id}
                    value={frecuencia.frecuencia_de_pago_id}
                  >
                    {frecuencia.frecuencia_de_pago_nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="end"
              spacing={1}
              alignItems="center"
            >
              {!stepper.isFirstStep && (
                <Button variant="outlined" size="small" onClick={stepper.back}>
                  Atrás
                </Button>
              )}

              <Button type="submit" variant="contained" size="small">
                Siguiente
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
